
import { Vue, Component, Prop } from 'vue-property-decorator';
import {
  EShopBusinessStatus,
  EShopBusinessStatusNum,
} from '@/common/enum/shop';
import moment, { Moment } from 'moment';
import lazyInject from '@/di';
import ShopService from '@/services/shop.service';
import CarService from '@/services/car.service';

@Component({})
export default class BusinessStatusControl extends Vue {
  @lazyInject(ShopService)
  shopService!: ShopService;

  @lazyInject(CarService)
  carService!: CarService;

  EShopBusinessStatus = EShopBusinessStatus;
  EShopBusinessStatusNum = EShopBusinessStatusNum;

  checkNumVisible = false;

  checkStringVisible = false;

  checkNum = '';

  checkString = '';

  reason = '';

  date: Moment | null = null;

  /**
   * 当前事件类型
   */
  type: any = EShopBusinessStatusNum.正常营业;

  random = 0;

  @Prop()
  shopCode!: string;

  get checkBeforeStopTitle(): string {
    return `为防止操作失误请输入数字：[${this.random}]`;
  }

  /**
   * 事件区分
   */
  changeBusinessStatus(type: any) {
    this.type = type;
    switch (type) {
      case EShopBusinessStatusNum.正常营业:
        this.startBusiness();
        break;
      case EShopBusinessStatusNum.暂停营业:
        this.checkBeforeStop();
        break;
      case EShopBusinessStatusNum.永久停业:
        this.$warning({
          title:
            '请与高德和德友惠技术人员确认待核销记录 并充分沟通后 再执行下架操作！',
          okText: '永久停业',
          onOk: this.checkBeforeStop,
          okType: 'danger',
        });
        break;
      case EShopBusinessStatusNum.惩罚下线:
        this.checkBeforeStop();
        break;
      case EShopBusinessStatusNum.下线:
        this.checkBeforeStop();
        break;
      default:
        break;
    }
  }

  /**
   * 暂停/停止 前确认逻辑
   */
  checkBeforeStop() {
    this.checkNum = '';
    this.random = Math.round(Math.random() * 1000);
    this.checkNumVisible = true;
  }

  /**
   * 恢复营业
   */
  async startBusiness() {
    const res = await this.carService.postCarShopStartBusiness(this.shopCode);
    if (!res) {
      return;
    }
    this.$emit('refresh');
  }

  handleNumCheck() {
    if (+this.checkNum === this.random) {
      this.checkNumVisible = false;
      this.checkNum = '';
      this.checkString = '';
      this.reason = '';
      this.date = null;
      this.checkStringVisible = true;
    } else {
      this.$message.error('输入错误！');
    }
  }

  /** 停业 */
  async handleStringCheck() {
    if (this.checkString === this.type) {
      if (!this.reason) {
        return this.$message.error(`${this.type}的原因不能为空！`);
      }

      switch (this.type) {
        case EShopBusinessStatusNum.暂停营业: {
          if (!this.date) {
            return this.$message.error('请选择恢复营业日期');
          }

          const res = await this.carService.postCarShopStopBusiness(
            this.shopCode,
            {
              reason: this.reason,
              startTime: `${this.date.format('YYYY-MM-DD')} 00:00:00`,
            },
          );
          if (!res) {
            return;
          }
          this.$emit('refresh');
          this.checkStringVisible = false;
          this.reason = '';
          break;
        }
        case EShopBusinessStatusNum.永久停业: {
          const res = await this.carService.postCarShopForeverStopBusiness(
            this.shopCode,
            this.reason,
          );
          if (!res) {
            return;
          }
          this.$emit('refresh');
          this.checkStringVisible = false;
          this.reason = '';
          break;
        }
        case EShopBusinessStatusNum.惩罚下线: {
          if (!this.date) {
            return this.$message.error('请选择恢复营业日期');
          }
          const res = await this.carService.postCarShopPenaltyOffline(
            this.shopCode,
            {
              reason: this.reason,
              start_business_time: `${this.date.format('YYYY-MM-DD')} 00:00:00`,
            },
          );
          if (!res) {
            return;
          }
          this.$emit('refresh');
          this.checkStringVisible = false;
          this.reason = '';
          break;
        }
        case EShopBusinessStatusNum.下线: {
          const res = await this.carService.postCarShopOfflineBusiness(
            this.shopCode,
            { reason: this.reason },
          );
          if (!res) {
            return;
          }
          this.$emit('refresh');
          this.checkStringVisible = false;
          this.reason = '';
          break;
        }
        default: {
          break;
        }
      }
    } else {
      this.$message.error('输入错误！');
    }
  }

  /** 惩罚下线 */
  async penalty() {
    // punitiveStopBusiness
  }

  /** 日期范围禁用 */
  public disabledDate(current: Moment) {
    return current < moment().add(-1, 'd');
  }
}
